import React from 'react';
import { Link } from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import {setOrderByNewest, setOrderByOldest,} from "../../../Features/Misc/activeSlice";


const SearchSubFilter = ({ totalResults, shownResults, numberOfResults }) => {
    const dispatch = useDispatch();
    const { searchOrderByNewest, searchOrderByOldest } = useSelector(state => state.active)


    const handleNewestClick = (e) => {
        e.preventDefault(); // Prevent default link behavior
        dispatch(setOrderByNewest());
    };

    const handleOldestClick = (e) => {
        e.preventDefault(); // Prevent default link behavior
        dispatch(setOrderByOldest());
    };


    return (
        <div className="flex items-center">
            <div className="flex items-end">
                <p className="text-white text-xl mb-0 hidden">
                    <i className="ri-sort-asc text-gold-accent mr-2 hidden"></i> Sort by
                </p>
                <nav className="ml-8 text-white space-x-5 hidden">
                    <button onClick={handleNewestClick} className={ searchOrderByNewest ? "relative after:absolute after:-bottom-2 after:left-1/2 after:-translate-x-1/2 after:content-[''] after:border-b-2 after:border-gold-accent after:w-6" : ""}>
                        Newest
                    </button>
                    <button onClick={handleOldestClick} className={ searchOrderByOldest ? "relative after:absolute after:-bottom-2 after:left-1/2 after:-translate-x-1/2 after:content-[''] after:border-b-2 after:border-gold-accent after:w-6" : ""}>
                        Oldest
                    </button>
                </nav>
            </div>
            <p className="hidden md:block ml-auto text-white text-lg">Showing <strong>{numberOfResults}</strong> results</p>
        </div>
    );
};

export default SearchSubFilter;